<template>
  <section class="landing-section">
    <b-container>
      <b-row>
        <b-col class="text-center">
          <h1 id="locations" data-aos="fade-up">Our Shops</h1>
        </b-col>
      </b-row>
      <b-row
        v-for="store in stores"
        :key="store.name"
        align-v="center"
        class="shop"
      >
        <b-col xs="12">
          <h2 data-aos="fade-up">{{ store.name }}</h2>
          <hr class="bg-boxx-red short" data-aos="fade-up" />
          <div class="mt-4 mb-4" data-aos="fade-up">
            <a
              class="btn btn-boxx-red"
              :href="`https://book.smartbooks365.com/shops/boxx-${store._id}`"
            >
              BOOK NOW
            </a>
            <a
              class="btn btn-outline-secondary ml-1"
              :href="store.googleMapsUrl"
              target="_blank"
            >
              DIRECTIONS
            </a>
          </div>
        </b-col>
        <b-col xs="12" md="6">
          <p class="lead text-justify" data-aos="fade-up">
            {{ store.description }}
          </p>
          <br />
          <h3 id="openingHours__header" data-aos="fade-up">
            Opening Hours
          </h3>
          <table
            class="openingHours__table"
            aria-describedby="openingHours__header"
            data-aos="fade-up"
          >
            <tr
              v-for="day in days"
              :key="`${store.name}__opening-hours__${day}`"
            >
              <td class="pr-4">{{ day | startCase }}</td>
              <td v-if="store.daysOpen[day]">
                {{ store.openingTimes[day] }} — {{ store.closingTimes[day] }}
                {{ store.walkInOnly[day] ? '(walk-in only)' : '' }}
              </td>
              <td v-else>CLOSED</td>
            </tr>
          </table>
        </b-col>
        <!-- <b-col xs="12" md="6">
          <div class="google-maps" data-aos="fade-up">
            <iframe
              :src="store.googleMapsEmbedUrl"
              :title="`${store.name} Location on Google Maps`"
              width="600"
              height="450"
              frameborder="0"
              style="border:0;"
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </div>
        </b-col> -->
      </b-row>
    </b-container>
  </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { startCase } from 'lodash';

export default {
  filters: {
    startCase: startCase
  },
  data() {
    return {
      days: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
      ]
    };
  },
  computed: mapGetters({
    stores: 'stores/storesList'
  }),
  methods: mapActions({
    fetchStores: 'stores/fetchStores'
  }),
  created() {
    this.fetchStores();
  }
};
</script>
